export default __webpack_public_path__ + "static/media/gallery_02.15ff2c7b.jpg";